import {useContext, useState} from 'react';
import {View, ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {
  Text,
  Pressable,
  RadioButton,
  ActionButton,
  DealerPersona,
} from '~/components/controls';
import Actionsheet, {Title, Actions} from '~/components/controls/Actionsheet';
import withDimensions from '~/components/hoc/with-dimensions';
import UserContext from '~/components/context/UserContext';

import {
  DIALOG_FOOTER_HEIGHT_IN_PX,
  DIALOG_HEADER_HEIGHT_IN_PX,
} from '../constants';

const ChangeDealerActionsheet = withDimensions(
  ({dimensions, dealer, onChangeDealer, onDismiss}) => {
    const {me} = useContext(UserContext);

    const [selectedValue, setSelectedValue] = useState(dealer);

    return (
      <Actionsheet visible={true} onDismiss={onDismiss}>
        <Title>Vestiging</Title>
        <Divider style={sy['bg-gray88']} />
        <ScrollView
          contentContainerStyle={{
            maxHeight: Math.min(
              dimensions.window.height -
                DIALOG_HEADER_HEIGHT_IN_PX -
                DIALOG_FOOTER_HEIGHT_IN_PX,
              600,
            ),
          }}>
          {me.dealers
            .sort((a, b) => a.city.localeCompare(b.city))
            .map((item) => (
              <View key={item.id} style={[sy['px-4']]}>
                <Pressable
                  onPress={() => setSelectedValue(item)}
                  style={[
                    sy['flex-row'],
                    sy['items-center'],
                    sy['py-4'],
                    sy['gap-4'],
                  ]}>
                  <RadioButton checked={selectedValue.id === item.id} />
                  <View style={[sy['flex-1']]}>
                    <Text style={[sy['truncate']]}>
                      {item.city}&nbsp;&middot;&nbsp;{item.short_name}
                    </Text>
                  </View>
                  <DealerPersona dealer_id={item.id} size={18} />
                </Pressable>
                <Divider style={[sy['bg-gray95']]} />
              </View>
            ))}
        </ScrollView>
        <Divider style={sy['bg-gray88']} />
        <Actions>
          <ActionButton onPress={onDismiss}>Annuleren</ActionButton>
          <ActionButton
            onPress={async () => {
              await onChangeDealer(selectedValue);
              onDismiss();
            }}>
            OK
          </ActionButton>
        </Actions>
      </Actionsheet>
    );
  },
);

export default ChangeDealerActionsheet;
